import { NavLink } from 'react-router-dom'
import React from 'react'
import { UserContext } from 'context/user-context'
import './style.css'

const TopMenu = () => {
    const user = React.useContext(UserContext)

    return (
        <div className="nav">
            <div className="nav__menu">
                <NavLink to='/about' exact className="nav__menu-item" activeClassName="menu-item_active">О клубе</NavLink>
                <NavLink to='/process' exact className="nav__menu-item" activeClassName="menu-item_active">Процессы</NavLink>
                <NavLink to='/events' className="nav__menu-item" activeClassName="menu-item_active">События</NavLink>
                <NavLink to='/bots' className="nav__menu-item" activeClassName="menu-item_active">Боты</NavLink>
                <NavLink to='/people' exact className="nav__menu-item" activeClassName="menu-item_active">Люди</NavLink>
                <NavLink to='/achivment' exact className="nav__menu-item" activeClassName="menu-item_active">Ачивки</NavLink>
                <NavLink to='/recommendation' className="nav__menu-item" activeClassName="menu-item_active">Рекомендации</NavLink>
            </div>
            <div className="nav__menu">
                <span data-tooltip="Чтобы отредактировать профиль, напишите Роме Ватриковскому">{user?.name} {user?.surname}</span>
                <NavLink to='/logout'>Выйти</NavLink>
            </div>
        </div>
    )
}

export default TopMenu
